import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1264ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tactics" }
const _hoisted_2 = { class: "operation-box" }
const _hoisted_3 = { class: "ws_mb12" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "value" }

import { PAGE_SIZES } from '@/common/constant'
import ConfigModal from './components/config-form-drawer.vue'
import { ref, onMounted } from 'vue'
import {
  alarmStrategyPage,
  alarmStrategyStartAndStop,
  alarmStrategyDelete,
  alarmStrategyDetail,
} from '@/api'
import { useWarningStore } from '@/stores/warning'
import moment from 'moment'
import {
  WARNING_STAUTS_ENUM,
  CODE_ENUM,
  WARNING_TYPE_ENUM,
  TACTICS_TIME_TYPE_ENUM,
  OPERATOR_TYPE,
  ALARM_MODE_TYPE,
} from '@/common/enum'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'
import i18n from '@/i18n'
import F1 from './components/form-drawer-1.vue'
import F2 from './components/form-drawer-2.vue'
import F3 from './components/form-drawer-3.vue'
import F4 from './components/form-drawer-4.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const getButtonList = ({ triggerStatusCode }: any) => {
  return [
    {
      type: 'config',
      text: getStatusText(triggerStatusCode),
    },
    {
      type: 'edit',
      text: t('W_TACTICS.btnEdit'),
    },
    {
      type: 'delete',
      text: t('W_TACTICS.btnDel'),
    },
    {
      type: 'detail',
      text: t('W_TACTICS.btnView'),
    },
  ]
}

const router = useRouter()

const advancedRef = ref()

const warningStore = useWarningStore()
warningStore.getTriggerType()

const warningStatusOps = [
  {
    label: t('W_TACTICS.statusOpen'),
    value: WARNING_STAUTS_ENUM.START,
  },
  {
    label: t('W_TACTICS.statusClose'),
    value: WARNING_STAUTS_ENUM.STOP,
  },
]

const getPopconfirmText = (triggerStatusCode: string) => {
  return WARNING_STAUTS_ENUM.START === triggerStatusCode
    ? t('W_TACTICS.closeTip')
    : t('W_TACTICS.openTip')
}

const getStatusText = (triggerStatusCode: string) => {
  return WARNING_STAUTS_ENUM.START === triggerStatusCode
    ? t('W_TACTICS.close')
    : t('W_TACTICS.open')
}

const toAdd = () => {
  warningConf.value = {
    visible: true,
    data: {},
  }
}

const warningConf = ref({
  visible: false,
  data: {},
})

// const toEdit = ({ id }: any) => {
//   warningConf.value = {
//     visible: true,
//     data: {
//       id,
//     },
//   }
// }

onMounted(() => {
  fetchList()
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const handleQuery = () => {
  pageParams.value.curPage = 1
  fetchList()
}

const tableData = ref([])

const tableLoading = ref(false)

const formInline = ref({
  strategyName: '',
  strategyStatusCode: '',
  strategyTypeCode: '',
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await alarmStrategyPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const changeStatus = ({ triggerStatusCode, id }: any) => {
  ElMessageBox.confirm(
    getPopconfirmText(triggerStatusCode),
    t('W_TACTICS.comfirmTitle'),
    {
      confirmButtonText: t('W_TACTICS.btnOk'),
      cancelButtonText: t('W_TACTICS.btnCancel'),
      type: 'warning',
    }
  )
    .then(() => {
      handleChangeStatus({ triggerStatusCode, id })
    })
    .catch(() => {})
}

const handleChangeStatus = async ({ triggerStatusCode, id }: any) => {
  const { START, STOP } = WARNING_STAUTS_ENUM
  const startOrStopCode = triggerStatusCode === START ? STOP : START
  const res: any = await alarmStrategyStartAndStop({
    startOrStopCode,
    triggerId: id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    fetchList()
  }
}

const deleteWarning = ({ id }: any) => {
  ElMessageBox.confirm(t('W_TACTICS.delTip'), t('W_TACTICS.delTitle'), {
    confirmButtonText: t('W_TACTICS.btnOk'),
    cancelButtonText: t('W_TACTICS.btnCancel'),
    type: 'warning',
  })
    .then(() => {
      toDeleteWarning({ id })
    })
    .catch(() => {})
}

const toDeleteWarning = async ({ id }: any) => {
  const res: any = await alarmStrategyDelete({
    triggerIds: [id],
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    fetchList()
    ElMessage.success(t('W_TACTICS.delSuccess'))
  } else if (res?.code === 30405) {
    ElMessageBox.alert(res.msg, t('W_TACTICS.delError'), {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('W_TACTICS.close'),
      type: 'warning',
      customClass: 'tactics_delete_error',
    }).catch()
  } else {
    ElMessage({
      message: res?.msg,
      type: 'error',
    })
  }
}

const aoiList: any = ref([
  {
    label: t('W_TACTICS.labelAoi'),
    key: 'aoiInfos',
    span: 24,
  },
  {
    label: t('W_TACTICS.alarmLevel'),
    key: 'alarmLevelValue',
    span: 24,
  },
])

const sensorList: any = ref([
  {
    label: t('W_TACTICS.labelTypeName'),
    key: 'triggerTypeName',
    span: 24,
  },
  {
    label: t('W_TACTICS.alarmLevel'),
    key: 'alarmLevelValue',
    span: 24,
  },
  {
    label: t('W_TACTICS.labelAttr'),
    key: 'sensorAttrCode',
    span: 24,
  },
])

const sensorList2: any = ref([
  {
    label: t('W_TACTICS.labelTypeName'),
    key: 'triggerTypeName',
    span: 24,
  },
  {
    label: t('W_TACTICS.alarmLevel'),
    key: 'alarmLevelValue',
    span: 24,
  },
  {
    label: t('W_TACTICS.triggerCondition'),
    key: 'sensorAttrCode',
    span: 24,
  },
  {
    label: t('W_TACTICS.alarmConditions'),
    key: 'sensorAttrCode2',
    span: 24,
  },
])

const eventList: any = ref([
  {
    label: t('W_TACTICS.labelTypeName'),
    key: 'triggerTypeName',
    span: 24,
  },
  {
    label: t('W_TACTICS.alarmLevel'),
    key: 'alarmLevelValue',
    span: 24,
  },
  {
    label: '事件详情',
    key: 'eventTypeValue',
    span: 24,
  },
])

const getShowList = (triggerTypeCode: any) => {
  if (triggerTypeCode === WARNING_TYPE_ENUM.AOI) {
    return aoiList.value
  } else if (triggerTypeCode === WARNING_TYPE_ENUM.SENSOR) {
    return sensorList.value
  } else if (triggerTypeCode === WARNING_TYPE_ENUM.SENSORINCRE) {
    return sensorList2.value
  } else {
    return eventList.value
  }
}

const detailModalConf: any = ref({
  visible: false,
  list: [],
  title: '',
})
const queryDatail = async ({ id }: any) => {
  const res: any = await alarmStrategyDetail({
    alarmStrategyId: id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const data = res?.data || {}
    const { triggerTypeCode } = data

    const list = getShowList(triggerTypeCode)
    const moList = list.map((item: any) => {
      const { key } = item
      return {
        ...item,
        value: formatterMap[key]
          ? formatterMap[key](data[key], data)
          : data[key],
      }
    })
    detailModalConf.value = {
      visible: true,
      list: moList,
      title: data.name,
    }
  }
}

const operatorList: any = [
  {
    value: OPERATOR_TYPE.GREATER,
    label: t('W_TACTICS.operator1'),
    unit: '>',
  },
  {
    value: OPERATOR_TYPE.LESS,
    label: t('W_TACTICS.operator2'),
    unit: '<',
  },
  {
    value: OPERATOR_TYPE.EQUAL,
    label: t('W_TACTICS.operator3'),
    unit: '=',
  },
  {
    value: OPERATOR_TYPE.GREATER_EQUAL,
    label: t('W_TACTICS.operator4'),
    unit: '≥',
  },
  {
    value: OPERATOR_TYPE.LESS_EQUAL,
    label: t('W_TACTICS.operator5'),
    unit: '≤',
  },
  {
    value: OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL,
    label: t('W_TACTICS.operator6'),
    unit: '≥',
    unit2: '≤',
  },
]

// 获取运算符
const getOperator = (key: string, operatorTypeCode: string) => {
  return (
    operatorList.filter((item: any) => {
      return item.value === operatorTypeCode
    })?.[0]?.[key] || ''
  )
}

const formatterMap = {
  aoiInfos: (value: any) => {
    return (value || []).map((item: any) => item.aoiName).join('、') || '-'
  },
  deviceInfos: (value: any) => {
    return (value || []).map((item: any) => item.deviceName).join('、') || '-'
  },
  sensorAttrCode: (value: any, data?: any) => {
    const { sensorInfo } = data
    const { sensors, conditionValue } = sensorInfo
    const desc = (sensors || [])
      .map((item: any) => {
        const {
          deviceName,
          sensorAttrName,
          thresholdStart,
          thresholdEnd,
          operatorTypeCode,
          conditionDuringTypeCode,
          conditionDuringTypeValue,
          conditionDuring,
          conditionDuringUnitValue,
        } = item
        let { thresholdUnitCode } = item
        thresholdUnitCode = thresholdUnitCode || ''
        const modeStr =
          conditionDuringTypeCode === ALARM_MODE_TYPE.SIMPLE
            ? ''
            : ' ' +
              (conditionDuringTypeValue + conditionDuring || '') +
              (conditionDuringUnitValue || '')
        // 区间范围
        if (operatorTypeCode === OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL) {
          return (
            deviceName +
            ' ' +
            sensorAttrName +
            '  ' +
            getOperator('unit', operatorTypeCode) +
            ' ' +
            thresholdStart +
            thresholdUnitCode +
            t('W_TACTICS.and') +
            getOperator('unit2', operatorTypeCode) +
            ' ' +
            thresholdEnd +
            thresholdUnitCode +
            modeStr
          )
        }
        return (
          sensorAttrName +
          '  ' +
          getOperator('unit', operatorTypeCode) +
          '  ' +
          thresholdStart +
          thresholdUnitCode +
          modeStr
        )
      })
      .join('  ;  ')

    return conditionValue + ' : ' + desc
  },
  sensorAttrCode2: (value: any, data?: any) => {
    const { sensorIncreAlarmInfo } = data
    const { sensors, conditionValue } = sensorIncreAlarmInfo
    const desc = (sensors || [])
      .map((item: any) => {
        const {
          deviceName,
          sensorAttrName,
          thresholdStart,
          thresholdEnd,
          operatorTypeCode,
          conditionDuringTypeCode,
          conditionDuringTypeValue,
          conditionDuring,
          conditionDuringUnitValue,
        } = item

        let { thresholdUnitCode } = item
        thresholdUnitCode = thresholdUnitCode || ''
        const modeStr =
          conditionDuringTypeCode === ALARM_MODE_TYPE.SIMPLE
            ? ''
            : ' ' +
              (conditionDuringTypeValue + conditionDuring || '') +
              (conditionDuringUnitValue || '')
        // 区间范围
        if (operatorTypeCode === OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL) {
          return (
            deviceName +
            ' ' +
            sensorAttrName +
            '  ' +
            getOperator('unit', operatorTypeCode) +
            ' ' +
            thresholdStart +
            thresholdUnitCode +
            t('W_TACTICS.and') +
            getOperator('unit2', operatorTypeCode) +
            ' ' +
            thresholdEnd +
            thresholdUnitCode +
            modeStr
          )
        }
        return (
          sensorAttrName +
          '  ' +
          getOperator('unit', operatorTypeCode) +
          '  ' +
          thresholdStart +
          thresholdUnitCode +
          modeStr
        )
      })
      .join('  ;  ')

    return conditionValue + ' : ' + desc
  },
  eventTypeValue: (value: any, data?: any) => {
    const { conditionDuring, conditionDuringUnitValue } = data
    if (conditionDuring) {
      return value + ' 持续' + conditionDuring + conditionDuringUnitValue
    }
    return value
  },
}

const aoiConf = ref({
  visible: false,
  data: {},
})

const sensorConf = ref({
  visible: false,
  data: {},
})

const sensorincreConf = ref({
  visible: false,
  data: {},
})
const eventConf = ref({
  visible: false,
  data: {},
})

const toForm = (command: any, data = {}) => {
  if (command === WARNING_TYPE_ENUM.AOI) {
    aoiConf.value = {
      visible: true,
      data,
    }
  } else if (command === WARNING_TYPE_ENUM.SENSOR) {
    sensorConf.value = {
      visible: true,
      data,
    }
  } else if (command === WARNING_TYPE_ENUM.SENSORINCRE) {
    sensorincreConf.value = {
      visible: true,
      data,
    }
  } else if (command === WARNING_TYPE_ENUM.EVENT) {
    eventConf.value = {
      visible: true,
      data,
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('W_TACTICS.strategyName'),
          prop: "strategyName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.strategyName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.strategyName) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('W_TACTICS.strategyType'),
          prop: "strategyTypeCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.strategyTypeCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.strategyTypeCode) = $event)),
              clearable: "",
              class: "ws_select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warningStore).triggerType, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('W_TACTICS.strategyStatus'),
          prop: "strategyStatusCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.strategyStatusCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.strategyStatusCode) = $event)),
              clearable: "",
              class: "ws_select"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(warningStatusOps, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_dropdown, {
          onCommand: _cache[3] || (_cache[3] = (e) => toForm(e, {}))
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(WARNING_TYPE_ENUM).AOI
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("电子围栏告警")
                  ]),
                  _: 1
                }, 8, ["command"]),
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(WARNING_TYPE_ENUM).SENSOR
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("传感器阈值告警 ")
                  ]),
                  _: 1
                }, 8, ["command"]),
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(WARNING_TYPE_ENUM).SENSORINCRE
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("传感器增量告警 ")
                  ]),
                  _: 1
                }, 8, ["command"]),
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(WARNING_TYPE_ENUM).EVENT
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("事件告警 ")
                  ]),
                  _: 1
                }, 8, ["command"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('W_TACTICS.btnNew')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "ws_common_table ws_mt20",
        stripe: "",
        data: tableData.value
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, {
            description: _ctx.$t('W_MSG.noData')
          }, null, 8, ["description"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('W_TACTICS.colName'),
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "triggerTypeName",
            label: _ctx.$t('W_TACTICS.colTypeName'),
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "pushMsgTotal",
            label: _ctx.$t('W_TACTICS.colPushMsgTotal'),
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "updateTime",
            label: _ctx.$t('W_TACTICS.colUpdateTime'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(moment)(scope.row.updateTime).format('YYYY-MM-DD HH:mm')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "triggerStatusCode",
            label: _ctx.$t('W_TACTICS.colStatus')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                class: "ml-2",
                type: 
              _unref(WARNING_STAUTS_ENUM).START === scope.row.triggerStatusCode
                ? 'success'
                : 'info'
            
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(WARNING_STAUTS_ENUM).START === scope.row.triggerStatusCode
                ? _ctx.$t('W_TACTICS.statusOpen')
                : _ctx.$t('W_TACTICS.statusClose')), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operation",
            label: _ctx.$t('W_TACTICS.colOperation'),
            width: "370"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: getButtonList(scope.row),
                scope: scope.row,
                onOnEdit: _cache[4] || (_cache[4] = (e) => toForm(e.triggerTypeCode, e)),
                onOnDelete: deleteWarning,
                onOnDetail: queryDatail,
                onOnConfig: changeStatus
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"]),
      _createVNode(ConfigModal, {
        visible: warningConf.value.visible,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((warningConf.value.visible) = $event)),
        data: warningConf.value.data,
        onOnSuccess: fetchList
      }, null, 8, ["visible", "data"]),
      _createVNode(_component_el_dialog, {
        modelValue: detailModalConf.value.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((detailModalConf.value.visible) = $event)),
        title: detailModalConf.value.title,
        width: 720,
        class: "detail-modal"
      }, {
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          _createVNode(_component_el_row, {
            class: "info",
            gutter: 30
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailModalConf.value.list, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: index,
                  span: item.span || 12
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.label) + " :", 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.value), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["span"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createVNode(F1, {
      visible: aoiConf.value.visible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((aoiConf.value.visible) = $event)),
      data: aoiConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(F2, {
      visible: sensorConf.value.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((sensorConf.value.visible) = $event)),
      data: sensorConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(F3, {
      visible: sensorincreConf.value.visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((sensorincreConf.value.visible) = $event)),
      data: sensorincreConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(F4, {
      visible: eventConf.value.visible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((eventConf.value.visible) = $event)),
      data: eventConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})